
import { Component, Vue } from "vue-property-decorator"
import router from "../router"
import HeartButton from "../assets/heartButton.vue"

@Component({
	components: {
		HeartButton,
	},
})
export default class Home extends Vue {
	get isMobileView() {
		return this.$store.state.isMobileView
	}

	goNext() {
		if (this.$router.currentRoute.path === "/") {
			this.$router.push("/quiz")
		}
	}
}
